import BannerProjects from '../../components/bannerProjects'
import CloudServices from '../../components/cloudServices'
import MaximaSeguranca from '../../components/maximaSeguranca'
import Rodape from '../../components/rodape'
import SegurancaCards from '../../components/segurancaCards'

function Seguranca() {
  return (
    <>
      <BannerProjects
        backgroundImage="../assets/cover-seguranca.png"
        bgMobile="../assets/cover-seguranca-mobile.png"
        title="/SEGURANÇA"
        titleBold=""
        iconSrc="../assets/icone-projectiva-nex2ai.png"
        iconAlt="Projectiva Nex2AI"
        iconText="nex"
        iconTextBold="2ai"
        descriptionBold=""
        description={
          <>
            Mais <span className="font-titillium-web-bold">segurança</span> em
            todas as etapas dos ciclos de desenvolvimento e entrega, com{' '}
            <span className="font-titillium-web-bold">confiabilidade</span>,{' '}
            <span className="font-titillium-web-bold">flexibilidade</span> e
            feedback rápido e contextual para as equipes envolvidas.
          </>
        }
        footerText="VERTICAL INNOVATION | Cloud"
        buttonText="Quero me conectar"
        buttonColor="from-[#FC0021] via-[#FC0021] to-[#5534D9]"
        brand="nex2ai"
      />
      <CloudServices />
      <SegurancaCards
        title={
          <p className="text-3xl text-center lg:text-left md:text-5xl lg:text-[40px] font-inter-light">
            <span className="bg-gradient-to-r from-[#FC0021] via-[#FC0021] to-[#4B3BDB] bg-clip-text text-transparent relative">
              {' '}
              Garanta mais segurança
            </span>{' '}
            e controle para os dados do seu negócio.
          </p>
        }
        cards={[
          {
            id: 1,
            icon: '../assets/protecao_icon.svg',
            title: 'Proteção de APIs',
            text: 'Implemente políticas de acesso eficazes para assegurar que apenas as pessoas designadas tenham acesso aos dados e recursos. Mantenha a segurança em dia com controle centralizado e auditorias regulares.',
            glowColor: '#FC0021',
          },
          {
            id: 2,
            icon: '../assets/politicas_icon.svg',
            title: 'Políticas e Gestão de Acessos',
            text: 'Proporcionamos suporte contínuo para alinhar a infraestrutura aos objetivos do seu negócio.',
            glowColor: '#FC0021',
          },
          {
            id: 3,
            icon: '../assets/prevencao_icon.svg',
            title: 'Prevenção de Ameaças',
            text: 'Fique à frente das ameaças cibernéticas com soluções proativas que detectam e neutralizam riscos antes que causem danos. Proteja suas aplicações e responda rapidamente a incidentes.',
            glowColor: '#FC0021',
          },
          {
            id: 4,
            icon: '../assets/scan_icon.svg',
            title: 'Scan De Vulnerabilidades',
            text: 'Identifique e corrija vulnerabilidades em sua infraestrutura antes que sejam exploradas. Mantenha seus sistemas seguros com verificações regulares e correções automatizadas.',
            glowColor: '#FC0021',
          },
          {
            id: 5,
            icon: '../assets/compliance_icon.svg',
            title: 'Monitoramento e Compliance',
            text: 'Garanta a conformidade com regulamentações e a segurança dos dados com monitoramento contínuo e relatórios detalhados. Mantenha-se em conformidade e evite riscos com alertas em tempo real.',
            glowColor: '#FC0021',
          },
          {
            id: 6,
            icon: '../assets/devsecops_icon.svg',
            title: 'DevSecOps',
            text: 'Integre segurança em todas as fases do desenvolvimento de software com DevSecOps. Automatize testes de segurança e crie uma cultura de segurança para garantir software confiável e seguro.',
            glowColor: '#FC0021',
          },
          {
            id: 7,
            icon: '../assets/monitoramento_icon.svg',
            title: 'Monitoramento de Eventos de Segurança',
            text: 'Monitore e analise eventos de segurança em tempo real para detectar e responder rapidamente a incidentes, garantindo a integridade dos seus sistemas.',
            glowColor: '#FC0021',
          },
          {
            id: 8,
            icon: '../assets/protecao_dados_icon.svg',
            title: 'Proteção De Dados',
            text: 'Proteja os dados da sua empresa e clientes com criptografia forte, gerenciamento de chaves e backups seguros. Mantenha a confiança e cumpra as regulamentações de proteção de dados.',
            glowColor: '#FC0021',
          },
        ]}
      />
      <MaximaSeguranca
        backgroundImage="/assets/cover-maxima-seguranca.png"
        text={
          <>
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#FC0021] via-[#FC0021] to-[#4B3BDB]">
              Máxima segurança e proteção
            </span>{' '}
            para seus dados e infraestrutura com soluções eficientes e
            confiáveis.
          </>
        }
        buttonText="Conheça nossas soluções"
        buttonTextColor="#FC0021"
        buttonLink="#"
      />
      <Rodape />
    </>
  )
}

export default Seguranca
